import invariant from "invariant";
import get_type_key from "./get_type_key";
import { infoTypeToFieldType } from "data/util/infoTypeToFieldType";
import entityFieldMetaStore from "data/meta/entityFieldMetaStore";
import TableColumnMetaStore from "data/meta/TableColumnMetaStore";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// a and b are records, components is an array of three-tuples:
// (String fieldname, String|int type, boolean ascending)
const compareRecords = (a, b, components) =>
    arrayBuilder(components)(a, b);

// components are objects w/ key, type, ascending keys, a and b are records
export const objectBuilder = components => (a, b) => {
    for (const {key, type, ascending} of components) {
        let af = a.get(key);
        let bf = b.get(key);
        if (af == null && bf == null) continue;
        if (!ascending) { // descending
            const temp = af;
            af = bf;
            bf = temp;
        }
        if (af == null) return -1;
        if (bf == null) return 1;
        // type-based restatement if both are non-null
        switch (typeof type === "string" ? type : get_type_key(type)) {
            case "STRING":
                af = af.toLowerCase();
                bf = bf.toLowerCase();
                break;
            case "INTEGER":
            case "DECIMAL":
                break;
            case "INTERVAL":
                // Moment.duration instances
                af = af.asMilliseconds();
                bf = bf.asMilliseconds();
                break;
            case "TZTIMESTAMP":
            case "TIME":
            case "DATE":
            case "DATETIME":
                // all Moment instances...
                af = af.valueOf();
                bf = bf.valueOf();
                break;
            case "CHOICE":
                af = af.toString();
                bf = bf.toString();
                break;
            case "ASSOCIATION":
                // todo: multi-valued associations
                af = af.compareTo(bf);
                bf = 0;
                break;
            default:
                throw new Error(`Unknown field type: ${type}`);
        }
        // if comparisons are non-zero, call it
        if (af < bf) return -1;
        if (af > bf) return 1;
    }
    return 0; // didn't find any diffs, so they're equivalent.
};

// components are arrays w/ key, type, ascending elements, a and b are records
export const arrayBuilder = components =>
    objectBuilder(components.map(it => ({
        key: it[0],
        type: it[1],
        ascending: it[2],
    })));

const typeForKey = (entityKey, fieldKey) =>
    infoTypeToFieldType(entityFieldMetaStore.getInfo(entityKey, fieldKey).type);

const comparator_cache = {};
const cc_stat = {
    get: 0,
    hit: 0,
    miss: 0,
    stale: 0,
    put: 0,
    purge: 0,
};
window.comparator_cache_stat = cc_stat;
const cc_get = (key, info) => {
    cc_stat.get += 1;
    const c = comparator_cache[key];
    if (c == null) {
        cc_stat.miss += 1;
        return;
    }
    if (c.info !== info) {
        cc_stat.stale += 1;
        return;
    }
    cc_stat.hit += 1;
    return c.comparator;
};
const cc_put = (key, info, comparator) => {
    cc_stat.put += 1;
    const keys = Object.keys(comparator_cache);
    if (keys.length > 100) {
        for (let i = 0; i < 25; i++) {
            cc_stat.purge += 1;
            delete comparator_cache[keys[i]];
        }
    }
    comparator_cache[key] = {
        info,
        comparator,
    };
};

export const comparatorForField = info => {
    invariant(
        info && info.key && info.otherEntityKey,
        "comparatorForField must be passed a valid fieldInfo"
    );
    const key = info.entityKey + "." + info.key;
    const comparator = cc_get(key, info);
    if (comparator !== undefined) return comparator;

    if (info.orderingComponents && info.orderingComponents.length > 0) {
        // if a field defines a sort order, use the field's ordering components.
        const components = info.orderingComponents.map(it => ({
            ...it,
            type: typeForKey(info.otherEntityKey, it.key),
        }));
        const c = objectBuilder(components);
        cc_put(key, info, c);
        return c;
    }

    // order is undefined.
    cc_put(key, info, null);
    return null;
};

export const comparatorForEntity = info => {
    const comparator = cc_get(info.key, info);
    if (comparator !== undefined) return comparator;

    const comps = info.orderingComponents;
    if (!comps) {
        throw new Error("'" + info.key + "' is not Comparable.");
    }
    const c = arrayBuilder(comps.map(it => [
        it.key,
        TableColumnMetaStore.getInfoByName(
            info.tableKey,
            entityFieldMetaStore.getInfo(
                info.key,
                it.key
            ).logicalColumn
        ).type,
        it.ascending
    ]));
    cc_put(info.key, info, c);
    return c;
};

export default compareRecords;



// WEBPACK FOOTER //
// ./app/jsmodel/compareRecords.js